export enum VIEWER_MODE {
    TOGGLE_MODE_1 = 'toggleMode1',
    TOGGLE_MODE_2 = 'toggleMode2'
}